/* eslint-disable react/require-default-props */
import { CircularProgress } from '@mui/material';

import { CompanyCommentData } from '../../../../../../api/theHive/companyComments/types';
import { formatDateAndTime } from '../../../../../../helpers';
import { RichTextViewer } from '../../../../../Announcements/components/RichTextViewer';
import { CommentCard, CommentMeta, EmptyState, NoticeTag } from './styles';

interface CommentListProps {
  comments: CompanyCommentData[];
  loading: boolean;
  emptyText: string;
  // Rotula o edital de origem — usado só na seção de histórico.
  showNotice?: boolean;
}

export function CommentList({
  comments,
  loading,
  emptyText,
  showNotice = false,
}: CommentListProps): JSX.Element {
  if (loading) return <CircularProgress size={20} />;

  if (comments.length === 0) return <EmptyState>{emptyText}</EmptyState>;

  return (
    <>
      {comments.map((comment) => (
        <CommentCard key={comment.id}>
          {showNotice && (
            <NoticeTag>
              {comment.notice_name || `Edital ${comment.notice_id}`}
            </NoticeTag>
          )}
          <CommentMeta>
            {formatDateAndTime(comment.created_at)}
            {comment.author?.name ? ` · ${comment.author.name}` : ''}
          </CommentMeta>
          <RichTextViewer content={comment.body} />
        </CommentCard>
      ))}
    </>
  );
}
